import { PortfolioModernView } from "../../public/PortfolioLayouts/PortfolioModernView";

export const BuyerProductsList = () => {
  return <PortfolioModernView isPublic={false} />;
};
